export const ScholarityLevelOptionSanarFinancing = (options, isFilter) =>
  isFilter && options ? options.filter(option => [5, 6, 7, 8].includes(option.id)) : options
